import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import { filterAndSortBySubgroup } from '../utils';
import { IIncomeStructureFormValues } from '../../NatureOfBusinessFormProvider/types';
import ExportIncomeOtherPct from './ExportIncomeOtherPct';
import ExportIncomeYearFieldsPct from './ExportIncomeYearFieldsPct';

const ExportIncomeExtendedPct = () => {
  const { watch } = useNatureOfBusinessForm();
  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const exportIncomePercentages =
    incomeStructure?.exportIncomePercentages || {};
  const exportIncomeExtendedPct = filterAndSortBySubgroup(
    exportIncomePercentages,
    INCOME_SUBGROUP_CATEGORY.EXPORT_INCOME
  );

  return (
    <>
      {exportIncomeExtendedPct.map(([key, item]) => (
        <Flex key={key} width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350} justifyItems={'end'}>
            <InputLabel sx={{ textAlign: 'right' }}>
              ประเทศ{item.incomeCategory?.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (%)
            </Typography>
          </Box>
          <ExportIncomeYearFieldsPct keyItem={key} />
        </Flex>
      ))}
      {exportIncomeExtendedPct.length > 0 && <ExportIncomeOtherPct />}
    </>
  );
};

export default ExportIncomeExtendedPct;
